import { forwardRef } from 'react'
import type { ChangeEventHandler, FocusEventHandler, FormEvent, MouseEventHandler, ReactNode, Ref } from 'react'
import classNames from 'classnames'

import { SearchIcon } from 'components/icons/Icon'
import styles from './styles/SearchInput.css'

interface SearchInputProps {
  children?: ReactNode
  className?: string
  inputClass?: string
  buttonClass?: string
  buttonIconClass?: string
  placeholder?: string
  value?: string
  onSubmit?: (event: FormEvent) => void
  onChange?: ChangeEventHandler<HTMLInputElement>
  onClick?: MouseEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
  onFocus?: FocusEventHandler<HTMLInputElement>
  inputRef?: Ref<HTMLInputElement>
  label?: string
  disabled?: boolean
}

export const SearchInput = forwardRef<HTMLFormElement, SearchInputProps>(
  (
    {
      children,
      className,
      inputClass,
      buttonClass,
      buttonIconClass,
      placeholder = 'Search by title, author, keywords, or DOI',
      value,
      onSubmit,
      onChange,
      onClick,
      onBlur,
      onFocus,
      inputRef,
      label = 'search',
      disabled = false
    },
    ref
  ) => {
    const handleSubmit = (e: FormEvent) => {
      e.preventDefault()
      if (onSubmit) onSubmit(e)
    }

    return (
      <form
        className={classNames(styles.searchInput, className, { [styles.disabled]: disabled })}
        onSubmit={handleSubmit}
        ref={ref}
      >
        {children}

        <input
          ref={inputRef}
          aria-label={label}
          data-showdropdown
          autoComplete='off'
          className={classNames(styles.input, inputClass)}
          type='text'
          value={value}
          placeholder={placeholder}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          onClick={onClick}
          disabled={disabled}
        />
        <button
          type='submit'
          className={classNames(styles.button, buttonClass)}
          aria-label='search-button'
          disabled={disabled}
        >
          <SearchIcon size={20} className={classNames(styles.icon, buttonIconClass)} />
        </button>
      </form>
    )
  }
)

SearchInput.displayName = 'SearchInput'

export default SearchInput
